<template>
  <header>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light hidden-pc">
      <div
        class="container-fluid position-fixed bg-white"
        style="
          margin: 40px 40px 35px -22px;
          padding: 40px 40px 0px 40px;
          z-index: 99;
          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(0, 0, 0, 0.1);
        "
      >
        <div
          class="
            collapse
            navbar-collapse
            d-flex
            justify-content-between
            text-black
          "
          id="navbarExample01"
        >
          <h4 class="mb-2 text-black text-center">
            <b>STOCK4D</b>
          </h4>
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <div v-for="(data, i) in stock" :key="i" :value="data">
              <a class="nav-link" :href="`#${data.name.split(' ')[0]}`">{{
                data.name.split(" ")[0]
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="hidden-mobile">
      <MobileMenu :nav="stock" @close="close" v-if="modal" />
      <button
        class="btn btn-warning mobile-menu mt-2 ml-2 p-0 position-fixed"
        @click="open"
      >
        <h1 style="font-size: 40px" class="m-0 pr-2 pl-2">≡</h1>
      </button>
      <!-- <button class="btn btn-warning mobile-menu mt-2 ml-2 p-0" @click="open">
        <h1 style="font-size: 40px" class="m-0 pr-2 pl-2">≡</h1>
      </button> -->
      <div class="col-12 p-3 head-mobile">
        <h4 class="mb-2 text-black text-center">
          <b>STOCK4D</b>
        </h4>
      </div>
    </div>
    <!-- Navbar -->
  </header>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import MobileMenu from "./MobileMenu";
export default {
  components: { MobileMenu },
  name: "app",
  data() {
    return {
      modal: false,
    };
  },
  props: {
    stock: {
      Type: Object,
    },
  },

  methods: {
    open() {
      this.modal = true;
    },
    close() {
      this.modal = false;
    },
  },
};
</script>
<style>
a {
  color: black;
}
a:hover {
  color: rgb(56, 56, 56);
}
.mobile-menu {
  display: flex;
  position: absolute;
  z-index: 20;
}
.head-mobile {
  background: linear-gradient(
    90deg,
    rgba(255, 136, 0, 0.308) 0%,
    rgba(255, 136, 0, 0.075) 100%
  );
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.test {
  background-color: rgba(255, 197, 110, 0.6);

  background: linear-gradient(
    90deg,
    rgba(255, 197, 110) 0%,
    rgba(255, 197, 110, 0.6) 100%
  );
}
</style>